import script from "./UpdateInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpdateInfoDialog.vue?vue&type=style&index=0&id=21c39f8e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c39f8e"]])

export default __exports__